/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export let DocumentsTableColumnTypes = /*#__PURE__*/function (DocumentsTableColumnTypes) {
  DocumentsTableColumnTypes["DocumentNameColumn"] = "DocumentNameColumn";
  DocumentsTableColumnTypes["DocumentUploadedByColumn"] = "DocumentUploadedByColumn";
  DocumentsTableColumnTypes["DocumentUploadedOnColumn"] = "DocumentUploadedOnColumn";
  return DocumentsTableColumnTypes;
}({});